/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
export var defaultThemeContextValue = {
  fieldsSize: 'M',
  actionsSize: 'M'
};
export var themeContextObj = /*#__PURE__*/React.createContext(defaultThemeContextValue);
export var ThemeContextProvider = themeContextObj.Provider;